export default "__VITE_PUBLIC_ASSET__3b19a3f5__"